import { createGlobalStyle } from "styled-components";

const NotifyResultStyled = createGlobalStyle`
  .custom-notification{
    z-index: 99999;
     &.error {
        border: 1px solid #ffa39e;
        border-bottom-width: 3px;
        background: #fff1f0;
    }

    &.warning {
        border: 1px solid #ffe58f;
        border-bottom-width: 3px;
        background: #fffbe6;
    }

    &.success {
        border: 1px solid #b7eb8f;
        border-bottom-width: 3px;
        background: #f6ffed;
    }
  }
`;

export default NotifyResultStyled;
